import API, {ErrorHandlerCallback} from "@irati/utils/services/API/utils/errorHandler/register"

export interface PBServiceProps {
  errorHandlers: ErrorHandlerCallback[]
}

function autobind(context: any) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(context)).forEach((prop) => {
    const dontBind = prop === "constructor" || typeof context[prop] !== "function"
    if (!dontBind) {
      context[prop] = context[prop].bind(context)
    }
  })
}

export default abstract class PBService {
  constructor(props: PBServiceProps) {
    autobind(this)
    props.errorHandlers.forEach((handler) => {
      API.add(handler)
    })
  }
}
